// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2023-08-31 16:05:31 +0200 (Thu, 31 Aug 2023) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 136445 $
//  Purpose   : workshop support package
// =============================================================================
//~ export const dashpanels = true
export const parts = true

// declare views with route and parts
import * as views from './views'
export {views}
